<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      <div slot="content">

        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 320px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="gridOptions"
                :row-data="rowData"
                :default-col-def="defaultColDef"
                @grid-ready="onGridReady"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

/**
 * * Tab 구분 컴포넌트
 */

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
    mixins: [],
    props: {
        docId: {
            Type: String
            , required: false
        },
        title: {
            Type: String
            , required: false
        }
    },
    components: {Layout},
    data() {
        return {
            rowData:[],
            gridOptions: {},

            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */

          columnDefs:[
            {
              headerName:'No',
              field:'no',
              width:100,
              cellStyle:{textAlign: 'center'},
              valueFormatter: function(params) {
                return params.node.rowIndex+1;
              }
            },
            {
              headerName: '확인자명',
              width:200,
              field:'creatorNm',
              cellStyle:{textAlign:'center'}
            },
            {
              headerName: '확인일시',
              width:300,
              field:'createDt',
              cellStyle:{textAlign:'center'},
              valueFormatter: (params) => {
                return this.getDateFormat(`${params.value}`)
              }
            },
          ],
          defaultColDef: {
            resizable: true,
            filter:true,
            sortable: true
          },
        }
    },
    created() {
        
        this.$bus.$on('input', (val) => {
            console.log('-> input bus on ', val);
        });
    },
    beforeMount() {

      this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
        checkboxRenderer: CheckboxCellRenderer,
      };

    },
    mounted() {
      this.goOpen();

      //pop slots modal move
      // $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        getDateFormat(val) {
          if (val) {
            return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
          }
        },
        onGridReady(){
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        onModelGroupChange(e){

        },
        onCellClicked(param){
          // this.$emit('close', param)
          // this.closeModal()
        },
        goOpen(){
          this.$store.commit('loading')
          this.$http.post("/api/boardMng/visitor/list" , {
            companyId: this.$store.state.loginInfo.compCd,
            docId : this.docId,
            sortType : "",
            processTime : "",
            }
          ).then(response => {
            if(response.data){
              this.rowData = response.data;
              // this.rowData = response.data.callModelSelPageList || []
            }

          }).finally(() => {
            this.$store.commit('finish')

          });
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 500px;
}

.display-area {
  :global(img) {
    width: 100%;
  }

.pop_min2 {
  //width: auto !important;
  min-width: 35% !important;
  overflow: hidden;
  }

}
</style>